import script from "./placeInformationGrid.vue?vue&type=script&setup=true&lang=js"
export * from "./placeInformationGrid.vue?vue&type=script&setup=true&lang=js"

import "./placeInformationGrid.vue?vue&type=style&index=0&id=cf59a150&scoped=true&lang=scss"

import exportComponent from "/home/steffen/Projekte/clubadmin/frontend/homepage/gc-schoenbuch/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-cf59a150"]])

export default __exports__